// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const BottomNavigation = registerClientReference(
    function() { throw new Error("Attempted to call BottomNavigation() from the server but BottomNavigation is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/shared/bottom-navigation/index.tsx",
    "BottomNavigation",
);
